import { FC, useEffect, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers';
import { getActiveExperiences, getDurations } from '../../../services/teamExperienceService';
import { ExperienceSummary } from '../../teamExperiences/models/ExperienceSummaryModel';
import { formatDateShortIntl2 } from '../../../helpers/FormatDate';
import { GenericModel } from '../../teamExperiences/models/GenericModel';
import Pagination from '../../components/Pagination';
import { useHistory } from 'react-router-dom';
import { EXPERIENCE_STATUS } from '../../teamExperiences/models/ExperienceStatus';
import { LoaderOverlay } from '../../../hooks/loader/LoaderOverlay';
import { CancelExperiencePolicyModal } from './CancelExperiencePolicyModal'
import { InviteMemberModal } from './InviteMemberModal';
import { getMaxPeople } from '../../experienceHostPreview/components/utils';
import { GuestsModal } from './GuestsModal';
import { defaultProfileImage, defaultVerticalImage } from '../../../utils/constants';
import { handleImageErrorGray } from '../../../utils/UtilsFiles';
import { formatDurationLabel, formatUsdAmount, pickDurationName } from '../../../utils/dateValidations';

interface PropsSectionActive {
}

const SectionActive: FC<PropsSectionActive> = ({ }) => {
    const [durations, setDurations] = useState<GenericModel[]>([]);
    const [paginationData, setPaginationData] = useState<any>(null);
    const [listExperiences, setListExperiences] = useState<ExperienceSummary[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const limit = 5;
    const history = useHistory()
    // funciones de cancelar
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const [selectedExperience, setSelectedExperience] = useState<ExperienceSummary|null>();
    // funciones de invitar
    const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
    // mostrar invitados
    const [isGuestsModalOpen, setIsGuestsModalOpen] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const duration = await getDurations();
            setDurations(duration?.results ?? [])
            await getList();
        }
        fetchData();
    },[])

    const getList = async (page:number=1,offset:number=0) => {
        setIsLoading(true);
        const experiences = await getActiveExperiences({ limit, offset, status: `${EXPERIENCE_STATUS.PUBLISHED},${EXPERIENCE_STATUS.PRE_LAUNCH},${EXPERIENCE_STATUS.PENDING}` });
        setPaginationData(experiences);
        setListExperiences(experiences?.results ?? []);
        setCurrentPage(page);
        setIsLoading(false);
    }

    const totalPages = paginationData
        ? Math.ceil(paginationData.count / limit)
        : 1;

    const handlePageChange = async (page: number) => {
        const offset = (page - 1) * limit;
        await getList(page,offset);
    };

    const enableEdit = (status:number) => {
        return (status == EXPERIENCE_STATUS.DRAFT || status == EXPERIENCE_STATUS.PENDING);
    }

    const enableCancel = (status:number) => {
        return (status == EXPERIENCE_STATUS.PUBLISHED || status == EXPERIENCE_STATUS.PRE_LAUNCH);
    }
    const enableInvited = (status:number, isPublic?: boolean) => {
        return !isPublic && (status == EXPERIENCE_STATUS.PUBLISHED || status == EXPERIENCE_STATUS.PRE_LAUNCH);
    }

    const goto = (status:number,id:number) => {
        switch(status){
            case EXPERIENCE_STATUS.DRAFT:
            case EXPERIENCE_STATUS.PENDING:
                history.push(`/experience/edit/${id}`);
                break;
            case EXPERIENCE_STATUS.PUBLISHED:
            case EXPERIENCE_STATUS.PRE_LAUNCH:
                history.push(`/experience/detail/${id}`);
                break;
            default:
                break;
        }
    }

    const handleCancel = (item:any) => {
        setSelectedExperience(item);
        setIsCancelModalOpen(true);
    }
    
    const handleOnCloseCancelModal = () => {
        setIsCancelModalOpen(false);
        setSelectedExperience(null);
    }
    
    const handleOnSubmitCancel = async () => {
        setIsCancelModalOpen(false);
        setSelectedExperience(null);
        await getList();
    }

    const handleInvite = async (item:any) => {
        await setSelectedExperience(item);
        await setIsInviteModalOpen(true);
    }

    const handleOnSubmitInvite = async () => {
        setIsCancelModalOpen(false);
        setSelectedExperience(null);
        await getList();
    }

    const handleOnOpenModalGuests = async (item:any) => {
        await setSelectedExperience(item);
        await setIsGuestsModalOpen(true)
    }

    return (
        <div className="tap-host-secction-experiences-past-wrapper">
            <div className={`tap-host-secction-experiences-past-list ${isLoading ? '' : 'd-none'}`}>
                <div className='loader-experience'></div>
            </div>
            <div className={`tap-host-secction-experiences-past-list`}>
                {(listExperiences ?? []).map((exp:ExperienceSummary, index:number) =>
                    (<div key={exp.id ?? index} className="tap-host-secction-experiences-past-card">

                        {/* LEFT IMAGE */}
                        <div className="tap-host-secction-experiences-past-img-wrapper tap-flex-center cursor-pointer" onClick={()=>history.push(`/experience/detail/${exp.id}`)}>
                            <img className="tap-host-secction-experiences-past-img" src={exp.coverImage ?? ''} onError={handleImageErrorGray} alt={exp.title}/>

                            <div className="tap-host-secction-experiences-past-img-overlay">
                                <div className="tap-host-secction-experiences-past-img-title">
                                    {exp.title}
                                </div>
                            </div>
                        </div>

                        {/* RIGHT CONTENT */}
                        <div className="tap-host-secction-experiences-past-details">

                            {/* HOSTS */}
                            <div className="tap-host-secction-experiences-past-host-group">
                                <div className="tap-host-secction-experiences-past-host">
                                    <img src={exp?.host?.profilePicture ?? defaultProfileImage} onError={(e) => {e.currentTarget.src = defaultProfileImage;}} className="tap-host-secction-experiences-past-host-img" alt={exp?.title} />
                                    <div className="tap-host-secction-experiences-past-host-name">
                                        {exp.host.firstName} {exp.host.lastName ?? ''}
                                    </div>
                                </div>
                                {/* {exp.hosts?.map((host, hIdx) => (
                                    <div key={hIdx} className="tap-host-secction-experiences-past-host">
                                        <img src={host.profilePicture} className="tap-host-secction-experiences-past-host-img" alt={host.name} />
                                        <div className="tap-host-secction-experiences-past-host-name">
                                            {host.name} {host.lastName ?? ''}
                                        </div>
                                    </div>
                                ))} */}
                            </div>

                            {/* INFO BOX */}
                            <div className="tap-host-secction-experiences-past-info-box cursor-pointer" onClick={()=>history.push(`/experience/detail/${exp.id}`)}>
                                <div className="tap-host-secction-experiences-past-info-row">
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-location">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_location.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            {exp.city !== '' ? exp.city : 'N/A'}
                                        </div>
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-calendar">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_date.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            {exp?.dates?.length>0 ? formatDateShortIntl2(exp?.dates[0]?.start) : 'N/A'}
                                        </div>
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-user">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_person.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            Max {exp.guestCapacity.max} Guests
                                        </div>
                                    </div>
                                </div>

                                <div className="tap-host-secction-experiences-past-info-row">
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-dollar">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_usd.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            {formatUsdAmount(exp.pricePerGuest) || 'N/A'}&nbsp;/&nbsp;{exp?.priceType === 2 || (exp as any)?.price_type === 2 ? 'Group' : 'Guest'}
                                        </div>
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-item">
                                        <div className="tap-host-secction-experiences-past-icon icon-clock">
                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_hour.svg' />&nbsp;
                                        </div>
                                        <div className="tap-host-secction-experiences-past-info-text">
                                            {formatDurationLabel(exp.duration, pickDurationName(durations, exp.durationType)) || 'N/A'}
                                        </div>
                                    </div>
                                    <div className="tap-host-secction-experiences-past-info-item"></div>
                                </div>
                            </div>

                            {/* BOTTOM ACTIONS */}
                            <div className="tap-host-secction-experiences-past-actions">
                                <div className="tap-host-secction-experiences-past-guests cursor-pointer" onClick={()=>handleOnOpenModalGuests(exp)}>
                                    <div className="tap-host-secction-experiences-past-icon icon-user">
                                        <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_past_person.svg' />&nbsp;
                                    </div>
                                    <div className="tap-host-secction-experiences-past-guests-text">
                                        Guests
                                    </div>
                                </div>
                                <div className="tap-host-secction-experiences-past-buttons"></div>
                                <div className="tap-host-secction-experiences-past-buttons">
                                    <div role='button' onClick={()=>history.push(`/experience/detail/${exp.id}`)} className="tap-host-secction-experiences-past-btn-view cursor-pointer">
                                        <span>preview</span>
                                    </div>
                                    {enableEdit(exp.status) && (<div role='button' onClick={()=>history.push(`/experience/edit/${exp.id}`)} className="tap-add-experience-2-btn-secondary">
                                        Edit
                                    </div>)}
                                    {enableCancel(exp.status) && (<div role='button' onClick={()=>handleCancel(exp)} className="tap-host-secction-experiences-past-btn-view cursor-pointer">
                                        <span>Cancelar</span>
                                    </div>)}
                                    {enableInvited(exp.status, exp.public ?? (exp as any).isPublic) && (<div role='button' onClick={()=>handleInvite(exp)} className="tap-add-experience-2-btn-secondary">
                                        INVITE GUESTS
                                    </div>)}
                                </div>
                            </div>

                        </div>
                    </div>)
                )}
            </div>
            {listExperiences.length > 0 && paginationData && (<div className='text-start mt-5'>
                <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
            </div>)}
            {listExperiences.length == 0 && (<div className="tap-host-secction-experiences-past-img-title justify-content-start text-dark">
                No experiences available.
            </div>)}
            <LoaderOverlay visible={isLoading} message={'Loading...'} />
            {selectedExperience && isCancelModalOpen && (<CancelExperiencePolicyModal experience={selectedExperience} show={isCancelModalOpen} onClose={handleOnCloseCancelModal} onLoad={setIsLoading} onSubmit={handleOnSubmitCancel} />)}
            {selectedExperience && isInviteModalOpen && (<InviteMemberModal experience={selectedExperience} durations={durations} show={isInviteModalOpen} onClose={()=>setIsInviteModalOpen(false)} onLoad={setIsLoading} onSubmit={handleOnSubmitInvite} />)}
            {isGuestsModalOpen && (<GuestsModal show={isGuestsModalOpen} onClose={()=>setIsGuestsModalOpen(false)} onLoad={setIsLoading} experience={selectedExperience}/>)}
        </div>

    )
}

export { SectionActive }